import { Component, OnInit } from '@angular/core';

/**
 * [Movemeback ui component library]
 * Chat component
 */
@Component({
  selector: 'mmb-ui-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
